import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      {/* Header */}
      <header className="bg-[#1A1A1A] border-b border-gray-800 py-4">
        <div className="container mx-auto px-4">
          <Link to="/" className="text-2xl font-bold bg-gradient-to-r from-[#00D9FF] to-[#0088FF] bg-clip-text text-transparent">
            WTPL
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8 bg-gradient-to-r from-[#00D9FF] to-[#0088FF] bg-clip-text text-transparent">
          Política de Privacidad
        </h1>
        
        <p className="text-gray-400 mb-8">Última actualización: Febrero 2025</p>

        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Información que Recopilamos</h2>
            <p className="mb-2">Recopilamos los siguientes tipos de información:</p>
            
            <h3 className="text-xl font-semibold text-white mt-4 mb-2">Información de Cuenta:</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>Nombre y dirección de correo electrónico (a través de Google OAuth)</li>
              <li>Foto de perfil de Google</li>
              <li>Información de suscripción y pagos</li>
            </ul>

            <h3 className="text-xl font-semibold text-white mt-4 mb-2">Información de Uso:</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>Tracks descargados y reproducidos</li>
              <li>Crates creados y organizados</li>
              <li>Calificaciones y preferencias</li>
              <li>Historial de búsquedas</li>
            </ul>

            <h3 className="text-xl font-semibold text-white mt-4 mb-2">Información Técnica:</h3>
            <ul className="list-disc list-inside space-y-1">
              <li>Dirección IP</li>
              <li>Tipo de navegador y dispositivo</li>
              <li>Cookies y tecnologías similares</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. Cómo Usamos su Información</h2>
            <p className="mb-2">Utilizamos su información para:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Proporcionar y mantener el servicio</li>
              <li>Procesar pagos y suscripciones</li>
              <li>Personalizar su experiencia (recomendaciones, Hot Picks)</li>
              <li>Enviar comunicaciones importantes sobre el servicio</li>
              <li>Mejorar y optimizar la plataforma</li>
              <li>Prevenir fraude y actividades maliciosas</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Compartir Información</h2>
            <p className="mb-2">No vendemos su información personal. Podemos compartirla con:</p>
            <ul className="list-disc list-inside space-y-1">
              <li><strong>Stripe:</strong> Para procesar pagos de forma segura</li>
              <li><strong>Google:</strong> Para autenticación OAuth</li>
              <li><strong>Cloudflare:</strong> Para seguridad y rendimiento</li>
              <li><strong>Autoridades legales:</strong> Si es requerido por ley</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Seguridad de Datos</h2>
            <p>
              Implementamos medidas de seguridad técnicas y organizativas para proteger su información:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Cifrado SSL/TLS en todas las comunicaciones</li>
              <li>Almacenamiento seguro en bases de datos protegidas</li>
              <li>Autenticación segura mediante Google OAuth</li>
              <li>Monitoreo continuo de actividades sospechosas</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Cookies</h2>
            <p>
              Utilizamos cookies esenciales para el funcionamiento del servicio, incluyendo:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Cookies de sesión para mantenerlo conectado</li>
              <li>Cookies de preferencias para recordar su configuración</li>
              <li>Cookies de seguridad para proteger contra fraude</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Sus Derechos</h2>
            <p className="mb-2">Usted tiene derecho a:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Acceder a su información personal</li>
              <li>Corregir datos inexactos</li>
              <li>Solicitar la eliminación de su cuenta y datos</li>
              <li>Exportar sus datos en formato portátil</li>
              <li>Cancelar su suscripción en cualquier momento</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Retención de Datos</h2>
            <p>
              Conservamos su información mientras su cuenta esté activa o según sea necesario para 
              proporcionar el servicio. Si elimina su cuenta, borraremos sus datos personales en un 
              plazo de 30 días, excepto cuando la ley requiera retención adicional.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Menores de Edad</h2>
            <p>
              WTPL no está dirigido a menores de 18 años. No recopilamos intencionalmente información 
              de menores. Si descubrimos que hemos recopilado datos de un menor, los eliminaremos 
              inmediatamente.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Cambios a esta Política</h2>
            <p>
              Podemos actualizar esta política ocasionalmente. Le notificaremos cambios significativos 
              por correo electrónico o mediante un aviso en la plataforma.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. Contacto</h2>
            <p>
              Para preguntas sobre privacidad o para ejercer sus derechos, contáctenos en:{' '}
              <a href="mailto:planetlyo@gmail.com" className="text-cyan-400 hover:underline">
                planetlyo@gmail.com
              </a>
            </p>
          </section>
        </div>

        {/* Back Link */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <Link to="/" className="text-cyan-400 hover:underline">
            ← Volver al inicio
          </Link>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
